'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Stack = exports.StackFrame = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _arrify = require('arrify');

var _arrify2 = _interopRequireDefault(_arrify);

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsTransitionGroup = require('react-addons-transition-group');

var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StackFrame = exports.StackFrame = function (_React$Component) {
	_inherits(StackFrame, _React$Component);

	function StackFrame(props) {
		_classCallCheck(this, StackFrame);

		var _this = _possibleConstructorReturn(this, (StackFrame.__proto__ || Object.getPrototypeOf(StackFrame)).call(this, props));

		_this.ee = new _events2.default();

		var transistionStyle = {
			transition: 'all 0.3s ease'
		};

		_this.baseStyle = Object.assign({
			position: 'absolute',
			width: '100%',
			height: '100%',
			overflow: 'auto'
		}, props.style);

		_this.startStyle = Object.assign({
			top: '100%',
			transform: 'rotateX(-30deg) scale(0.5)',
			opacity: '0'
		}, _this.baseStyle, transistionStyle);

		_this.endStyle = Object.assign({
			top: '0%',
			transform: 'rotateX(0deg) scale(1)',
			opacity: '1'
		}, _this.baseStyle, transistionStyle);

		_this.state = {
			style: _this.baseStyle
		};
		return _this;
	}

	_createClass(StackFrame, [{
		key: '__play',
		value: function __play(start, end) {
			var _this2 = this;

			this.setState(start);

			// forceUpdate and wait for DOM {{
			return Promise.all([new Promise(function (y) {
				return _this2.ee.once('update', y);
			}), new Promise(function (y) {
				return _this2.forceUpdate(y);
			})]).then(function () {
				return new Promise(function (y) {
					return setTimeout(y, 50);
				});
			}) // let DOM catch up
			// }}

			.then(function () {
				_this2.setState(end);
				return new Promise(function (y) {
					return setTimeout(y, 500);
				});
			});
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this.ee.emit('update');
		}
	}, {
		key: 'componentWillEnter',
		value: function componentWillEnter(done) {
			this.__play({ style: this.startStyle }, { style: this.endStyle }).then(function () {
				return done();
			});
		}
	}, {
		key: 'componentWillLeave',
		value: function componentWillLeave(done) {
			this.__play({ style: this.endStyle }, { style: this.startStyle }).then(function () {
				return done();
			});
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ style: this.state.style },
				this.props.children
			);
		}
	}]);

	return StackFrame;
}(_react2.default.Component);

var Stack = exports.Stack = function (_React$Component2) {
	_inherits(Stack, _React$Component2);

	function Stack(props) {
		_classCallCheck(this, Stack);

		var _this3 = _possibleConstructorReturn(this, (Stack.__proto__ || Object.getPrototypeOf(Stack)).call(this, props));

		_this3.state = {
			stack: (0, _arrify2.default)(props.children)
		};
		return _this3;
	}

	_createClass(Stack, [{
		key: 'push',
		value: function push(component) {
			this.setState({
				stack: [].concat(_toConsumableArray(this.state.stack), [component])
			});
		}
	}, {
		key: 'pop',
		value: function pop() {
			var stack = this.state.stack.slice(0, this.state.stack.length - 1); // eslint-disable-line no-unused-vars
			this.setState({ stack: stack });
		}
	}, {
		key: 'getChildContext',
		value: function getChildContext() {
			return { stack: this };
		}
	}, {
		key: 'render',
		value: function render() {
			var stack = this.state.stack;

			return _react2.default.createElement(
				'div',
				{ style: {
						position: 'relative',
						width: '100%',
						height: '100%'
					} },
				_react2.default.createElement(
					_reactAddonsTransitionGroup2.default,
					null,
					stack.map(function (frame, index) {
						return _react2.default.createElement(
							StackFrame,
							{ key: index, style: {
									zIndex: index,
									backgroundColor: 'white'
								} },
							frame
						);
					})
				)
			);
		}
	}]);

	return Stack;
}(_react2.default.Component);

Stack.childContextTypes = {
	stack: _react2.default.PropTypes.object
};


//////////////////
// WEBPACK FOOTER
// ./~/react-activity-stack/lib/index.js
// module id = 654
// module chunks = 0